module.exports = __webpack_public_path__ + "img/ai-chat-cmp-plus.82b5f06b.svg";